export function objectSnakeCaseParser(targetObject) {
  if (!targetObject || !isObject(targetObject)) return targetObject;
  const resultObject = {};

  for (var oldName in targetObject) {
    // transfer to snake_case
    let newName = oldName.replace(/([A-Z])/g, function($1) {
      return '_' + $1.toLowerCase();
    });

    const [firstCharacter] = newName;
    if (firstCharacter === '_') newName = newName.slice(1);

    resultObject[newName] = objectSnakeCaseParser(targetObject[oldName]);
  }
  return resultObject;
}

function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}



// WEBPACK FOOTER //
// ./app/utils/caseParser.js